import z from 'zod';

export const DuplicateType = z.enum(['hash', 'metadata']).catch('hash');
export type DuplicateType = z.infer<typeof DuplicateType>;

export const Duplicate = z.object({
    type: DuplicateType,
    ownerId: z.string(),
    receiptId: z.string(),
    fileId: z.string().nullish(),
    acceptedBy: z.string().nullish(),
    reviewedBy: z.string().nullish(),
});
export type Duplicate = z.infer<typeof Duplicate>;
